import React from 'react';
import popup from "../assets/images/pop-up.png"
import tick_mark from "../assets/images/tick-mark.png";
import { Link } from 'react-router-dom';


const SuccessPopup = ({orderId}) => {

  return (
    <>
        <div className="backdrop"></div>
        <div className="order-success-popup container rounded">
          <div className=" popup d-flex justify-content-center align-items-center">
            <img src={popup} className="pop-img" />
            <img src={tick_mark} className="tick_mark" />
          </div>
          <div>
            <p className='text-center'>Your order has been Places successfully.</p>
          </div>
          <div>
            <div className="cart-btn mt-3 d-flex justify-content-center align-items-center">
              <Link to="/">
                <button className="btn1 rounded btn btn-lg rounded-pill">
                  Back To Home
                </button>
              </Link>
              <Link to={"/order/"+orderId}>
                <button className="btn2 btn rounded-pill btn-lg ms-3 text-white">
                  Order Detail
                </button>
              </Link>
            </div>
          </div>
        </div>
    </>
  );
}

export default SuccessPopup;
